import React, { Component } from 'react';

import ParkinglocationModel from './ParkinglocationModel';

import { Select } from 'antd';
const Option = Select.Option;

class ParkinglocationSelect extends Component {

  state = {
    children: []
  }

  componentWillMount() {            
    ParkinglocationModel.getAll(true)
    .then(data => {     
      var children = [];   
      data.map((child, key) => {
      return children.push(<Option key={child.id}>{child.Code + ' - ' + child.Name}</Option>);
      });
      this.setState({
        children: children
      });
    });
  }

  render() {    
    return (    
      <Select
        size="default"
        showSearch
        placeholder={this.props.placeholder ? this.props.placeholder : 'Zvolte lokalitu'}
        optionFilterProp="children"
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} 
        onChange={(value) => { this.props.onChange(value) }}        
        {...this.props}>
          {this.state.children}
      </Select>
    );
  }
}

export default ParkinglocationSelect;


// WEBPACK FOOTER //
// ./src/components/ParkinglocationSelect.js